import { render, staticRenderFns } from "./CategoriesBaseForm.vue?vue&type=template&id=9b23c856&"
import script from "./CategoriesBaseForm.vue?vue&type=script&lang=js&"
export * from "./CategoriesBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports